import React  from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import './md.css'

const MarkdownContentView = ({ content }) => (
    <div className="markdown-content" style={{
        maxHeight: '160vh',
        overflowY: 'auto',
        padding: '1px 20px',
        borderRadius: '4px'
    }}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content || "Нет данных для отображения."}</ReactMarkdown>
    </div>
)

export default MarkdownContentView;
